(function () {
  'use strict'

  require('./scss/embed.scss')

  var MODULE_NAME = 'thismoment.embed.core'
  var templateUrl = require('./embed.tpl.html')

  require('angular')
    .module(MODULE_NAME, [
      require('../analytics'),
      require('./component'),
      require('./provider/embed-api')
    ])
    .component('thismomentEmbed', {
      templateUrl: templateUrl,
      bindings: {
        id: '@',
        a: '@',
        g: '<'
      },
      controller: thismomentEmbedController
    })

  thismomentEmbedController.$inject = ['SdkConfig', 'EmbedApi']
  function thismomentEmbedController (SdkConfig, EmbedApi) {
    var vm = this

    vm.$onInit = embedInit

    function embedInit () {
      vm.ready = false
      SdkConfig.set('account_id', vm.a)
      SdkConfig.set('group_id', vm.g)
      SdkConfig.set('embed_id', vm.id)

      EmbedApi.getConfig(vm.id, vm.a, vm.g).then((response) => {
        SdkConfig.set('tracking', response.analytics_enabled)
        SdkConfig.set('track_users', response.analytics_track_users)
        SdkConfig.set('segment_api_key', response.analytics_segment_api_key)
        SdkConfig.set('solution_id', response.solution_id)
        vm.config = response
        vm.type = response.type
        vm.ready = true
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/embed/embed.js